import { ToastService } from '../../ui';

/** Copy text to clipboard and show a brief confirmation toast. */
export function copyToClipboard(toast: ToastService, text: string, event?: Event): void {
  event?.stopPropagation();
  navigator.clipboard.writeText(text).then(() => {
    toast.open('Copied to clipboard', '', { duration: 1500 });
  });
}
